import { render, staticRenderFns } from "./CampaignStepAudience.vue?vue&type=template&id=0f453ed2&scoped=true"
import script from "./CampaignStepAudience.vue?vue&type=script&setup=true&lang=ts"
export * from "./CampaignStepAudience.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CampaignStepAudience.vue?vue&type=style&index=0&id=0f453ed2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f453ed2",
  null
  
)

export default component.exports